import '../src/javascript/uppy_full_document.js.erb';